<template lang="pug">
  transition(name="slide")
    .Forgot(:class="{'success': success}")
      
      .header

        .back-btn(
          v-if="!success"
          @click="back"
        )
          IconBackButton

        .title.u-text-width-bold
          template(v-if="success")
            | {{$t('auth.msg.forgot_pass_success')}}
          template(v-else="" v-html="$t('auth.msg.forgot_pass_error')")

        .desc.u-color-light
          Loading(v-if="is_form_loading")
          template(v-if="success")
            p {{$t('auth.msg.forgot_pass_success_msg')}}
          template(v-else="")
            p {{$t('auth.msg.forgot_pass_error_msg')}}
          
      .content

        form.form(
        v-show="!success"
        @submit.stop.prevent="submit")

          .col
            .line-form-container(
            :class="[{ 'is-danger': veeErrors.has('email') }, { 'filled' : email }]")
              label.line-form-label
                | {{$t('auth.field.email_address')}}
              input.line-form-control(
              name="email"
              autocomplete="email"
              type="text"
              v-model="email"
              :data-vv-as="$t('generic.field.email')"
              v-validate="'required|email|max:128'")

          .col.submit
            button.btn.btn-primary(
            type="submit"
            :disabled="is_form_loading")
              Loading(v-if="is_form_loading")
              span(v-else) {{$t('auth.action.forgot_pass')}}

        button.btn.btn-primary(
          v-show="success"
          type="button"
          :disabled="is_form_loading"
          @click="back"
        ) {{$t('auth.action.enter_to_account')}}

</template>

<script>
  import { mapActions, mapMutations } from 'vuex'

  export default {
    name: 'Forgot',

    data () {
      return {
        success: false,
        email: null
      }
    },

    computed: {

      password_type () {
        return this.typePassword ? 'text' : 'password'
      },

      is_form_loading () {
        return this.$wait.is('forgotPassword')
      }

    },

    methods: {

      ...mapActions('Auth', [
        'forgotPassword'
      ]),

      ...mapMutations('Auth', [
        'UPDATE_FORGOT_PASS_SUCCESS'
      ]),

      submit () {
        this.$validator.validateAll().then(result => {
          if (!result) return
          this.forgotPassword(this.email)
            .then(() => {
              this.success = true
              this.UPDATE_FORGOT_PASS_SUCCESS(true)
            })
            .catch(err => {
              this.showErrorToast(this.$getErrorMessage(this, err))
            })
        })
      },

      back() {
        this.$router.push({name: "login"});
      }

    }
  }
</script>

<style lang="scss" scoped>
  
  .slide {
    &-enter-active, &-leave-active {
      opacity: 1;
      transform: translateX(0%);
      transition: $transition-normal;
    }
    &-enter, &-leave-to {
      opacity: 0;
      transform: translateX(100%);
    }
  }

  .Forgot {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    position: relative;

    .header {
      user-select: none;
      width: 100%;
      max-width: 400px;
      position: relative;

      .title {
        font-size: 32px;
      }

      .back-btn {
        position: absolute;
        top: -100px;
        left: 0;
        cursor: pointer;
        transition: all .1s;
        color: #B6B7B8;

        &:hover {
          transform: scale(1.05);
        }

        @media only screen and (max-height: 600px) {
          top: -60px;
        }
      }

      .desc {
        margin-top: 15px;
      }
    }

    .content {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      max-width: 400px;
      margin-top: 20px;

      form {
        width: 100%;
      }

      .btn {
        margin-top: 20px;
        width: 100%;
      }
    }

    .footer {
      max-width: 400px;
      margin-left: auto;
      margin-right: auto;
      margin-top: 50px;
    }

    @media only screen and (max-width:767px) {
      .header, .content, .footer {
        max-width: unset;
      }
    }
  }

  .col {
    + .col {
      margin-top: 40px;
    }

    &.submit {
      margin-top: 50px;

      .btn {
        width: 100%;
      }
    }
  }

</style>
